import React from 'react'

const PencilIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.21967 3.46958C9.51256 3.17669 9.98744 3.17669 10.2803 3.46958L15.5303 8.71958C15.8232 9.01247 15.8232 9.48735 15.5303 9.78024C15.2374 10.0731 14.7626 10.0731 14.4697 9.78024L9.21967 4.53024C8.92678 4.23735 8.92678 3.76247 9.21967 3.46958Z"
      fill="#8591A1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6893 0.999886C11.9706 0.718582 12.3522 0.560547 12.75 0.560547C13.1478 0.560547 13.5294 0.718582 13.8107 0.999886L18 5.18923C18.2813 5.47053 18.4393 5.85206 18.4393 6.24989C18.4393 6.64771 18.2813 7.02924 18 7.31055L6.53033 18.7802C6.38968 18.9209 6.19891 18.9999 6 18.9999H1.5C1.10218 18.9999 0.720645 18.8419 0.43934 18.5605C0.158035 18.2792 0 17.8977 0 17.4999V13.3105C0 13.1136 0.0387986 12.9185 0.114181 12.7365C0.189562 12.5545 0.300052 12.3892 0.43934 12.2499L11.6893 0.999886ZM16.9393 6.24989L12.75 2.06055L1.5 13.3105L1.5 17.4999H5.68934L16.9393 6.24989Z"
      fill="#8591A1"
    />
  </svg>
)
export default PencilIcon
